const SELECT_CONTENT_DISPOSITION = {
  contentData: {
    contentText: 'HOW WOULD YOU LIKE TO RECEIVE YOUR ORDER ?',
    infoObject: {
      type: 'info',
      infoText: 'Manu availability and pricing may vary between order types.',
    },
    desktopImages: {
      alt: '',
      src: '',
    },
    orderTypes: [
      {
        buttonText: 'Delivery',
        selectDefault: false,
        type: 'delivery',
        showOption: true,
      },
      {
        buttonText: 'Take Away',
        selectDefault: false,
        type: 'takeAway',
        showOption: true,
      },
      {
        buttonText: 'Dine In',
        selectDefault: false,
        type: 'dineIn',
        showOption: true,
      },
    ],
    storeSection: {
      storeName: 'Takeaway from: KFC Fort Street',
      orderTimeStart: '4:00',
      orderTimeEnd: '4:30pm',
      buttonText: 'Change',
    },
  },
};
export default SELECT_CONTENT_DISPOSITION;
